import * as M from "@discovery/prelude/lib/data/maybe";
import { HeaderVariants, Tags, Typography } from "../../atoms/typography";
import Strings from "../../../utils/hardcoded.json";
import * as styles from "./styles.css";
const emptySearchResults = require("./emptySearch.png");
export const EmptySearchResults = ({ origin }) => (React.createElement(React.Fragment, null, origin === "desktop" ? (React.createElement("div", { className: styles.noResultsFoundWrapper },
    React.createElement(Typography, { classNameM: M.of(styles.noResultsText), variant: HeaderVariants.headingSix, tag: Tags.h6 },
        React.createElement(React.Fragment, null, Strings.NO_SEARCH_RESULT)))) : (React.createElement("img", { className: styles.imageWrapper, src: emptySearchResults, alt: "no search results" }))));

